import masterChangelog from "../master-changelog.json";

export default masterChangelog;